import React from 'react'
import { Form2 } from '../Formulario/Form2'

export const Contacto = () => {
  return (
    <Form2 />
  )
}
